import { render, staticRenderFns } from "./detailsAdd.vue?vue&type=template&id=2d1b2514&scoped=true&"
import script from "./detailsAdd.vue?vue&type=script&lang=js&"
export * from "./detailsAdd.vue?vue&type=script&lang=js&"
import style0 from "./detailsAdd.vue?vue&type=style&index=0&id=2d1b2514&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1b2514",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1b2514')) {
      api.createRecord('2d1b2514', component.options)
    } else {
      api.reload('2d1b2514', component.options)
    }
    module.hot.accept("./detailsAdd.vue?vue&type=template&id=2d1b2514&scoped=true&", function () {
      api.rerender('2d1b2514', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerMappingDraft/components/detailsAdd.vue"
export default component.exports